<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="addInsurance">
            <div class="h2">Add new insurance</div>
            <div class="container-fluid bg-light py-3">
                <div class="messages"></div>
                <div class="controls">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label for="name" class="mb-0 font-weight-bold">Name</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="insurance.name === '' && isSubmit? 'border-danger':''">
                                    <input type="text" autocomplete="off"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Insurance name"
                                           id="name"
                                           v-model="insurance.name">
                                </div>
                                <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
                            </div>

                            <div class="form-group">
                                <label for="description" class="mb-0 font-weight-bold">Description</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="insurance.description === '' && isSubmit? 'border-danger':''">
                                            <textarea class="form-control border-0 py-0 shadow-none form-input"
                                                      v-model="insurance.description"
                                                      id="description"
                                                      placeholder="Insurance description"></textarea>
                                </div>
                                <div class="text-danger" v-if="errors.description">{{ errors.description }}</div>
                            </div>

                            <div class="form-group">
                                <label for="type" class="mb-0 font-weight-bold">Insurance type</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="insurance.type === '' && isSubmit? 'border-danger':''">
                                    <select class="form-control border-0 py-0 shadow-none pr-5"
                                            id="type"
                                            v-model="insurance.type">
                                        <option :value="type" v-for="(typeName, type) in insuranceTypes">{{ typeName }}</option>
                                    </select>
                                </div>
                                <div class="text-danger" v-if="errors.type">{{ errors.type }}</div>
                            </div>

                            <div class="form-group">
                                <label for="price-type" class="mb-0 font-weight-bold">Price type</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="insurance.price_type === '' && isSubmit? 'border-danger':''">
                                    <select class="form-control border-0 py-0 shadow-none pr-5"
                                            id="price-type"
                                            v-model="insurance.price_type">
                                        <option :value="priceType" v-for="(priceTypeName, priceType) in priceTypes">{{ priceTypeName }}</option>
                                    </select>
                                </div>
                                <div class="text-danger" v-if="errors.price_type">{{ errors.price_type }}</div>
                            </div>

                            <div class="form-group">
                                <label for="duration" class="mb-0 font-weight-bold">Duration</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <input type="number" min="0"
                                           autocomplete="off"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           v-model="insurance.duration"
                                           id="duration"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.duration">{{ errors.duration }}</div>
                            </div>

                            <div class="form-group">
                                <label for="paid-by" class="mb-0 font-weight-bold">Paid by</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <select class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="insurance.paid_by"
                                            id="paid-by"
                                            required
                                    >
                                        <option :value="paidByType" v-for="(paidByName, paidByType) in insurancePaidByTypes">{{ paidByName }}</option>
                                    </select>
                                </div>
                                <div class="text-danger" v-if="errors.paid_by">{{ errors.paid_by }}</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary btn-lg" @click="validation()">Save</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-muted"></p>
                    </div>
                </div>
            </div>
        </form>
        <a href="/products" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "InsuranceCreate",
    props: {
        priceTypes: {type: Object, required: true},
        insuranceTypes: {type: Object, required: true},
        insurancePaidByTypes: {type: Object, required: true},
    },
    data() {
        return {
            insurance: {duration: 0, paid_by: 2},
            isSubmit: false,
            errors: {},
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        addInsurance() {
            let uri = '/insurances';
            this.errors = {};
            axios.post(uri, this.insurance).then((response) => {
                window.location.href = `/products`;
            }).catch(err => {
                const msg = err.response.data.message;
                this.flashMessage.error({
                    title: '',
                    message: msg,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);

                if (err.response.data.errors) {
                    let val;
                    for(let key in err.response.data.errors) {
                        val = err.response.data.errors[key] ? err.response.data.errors[key][0] : '';
                        this.$set(this.errors, key, val);
                    }
                }
            });
        }
    }
}

</script>
